module.exports = __webpack_public_path__ + "431dc1859f63e3aa91f0b9d27998a95d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/modern-mansion-empty.png
// module id = 318
// module chunks = 0